export const GIFTCARD_ENDPOINTS = {
  serviceProviderDetails: (id: string) => `service-providers/${id}`,
  bundleDetails: (id: string) => `bundles/${id}`,
  financialInfo: (serviceProviderItemId: string) =>
    `service-providers/items/${serviceProviderItemId}/financial-info`,
  exchangeRates: 'exchange-rates',
  bundleExchangeRates: 'exchange-rates/bundles',
  buyItem: (serviceProviderItemId: string) =>
    `service-providers/buy-item/${serviceProviderItemId}`,
  buyBundle: (bundleId: string) => `service-providers/buy-bundle/${bundleId}`,
  buyItemByWallet: (serviceProviderItemId: string) =>
    `service-providers/buy-item/${serviceProviderItemId}/by-wallet`,
  buyBundleByWallet: (bundleId: string) =>
    `service-providers/buy-bundle/${bundleId}/by-wallet`,
} as const;
